const ENABLE_WECOM_REPORT_GATE_FOR_ALL = false;

const WECOM_REPORT_GATE_EVAL_IDS = [
  "5162660557791170561",
];

export function shouldUseWecomReportGate(evalId) {
  if (ENABLE_WECOM_REPORT_GATE_FOR_ALL) {
    return true;
  }

  return WECOM_REPORT_GATE_EVAL_IDS.includes(String(evalId));
}
